var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-embed',{attrs:{"type":"object","aspect":_vm.aspect}},[_c('div',{ref:"map",staticClass:"w-100 h-100"})])}
var staticRenderFns = []

export { render, staticRenderFns }